<!-- Input checkbox

//utilização:
  <input-checkbox label="teste" v-model="entity.part.cliente" value-checked="S" value-unchecked="N" metadata-field="metadata.part.cliente.help"></input-checkbox>

//eventos emit
v-on:input(value)
-->

<template>
  <!--
  <div class="col-md-3 col-3">
    <div class="form-check">
      <div class="custom-control custom-checkbox">
        <input type="checkbox" class="custom-control-input" id="customCheck1"
            ref="cb"
            :checked="checked"
            :value="vvalue"
            @change="updateValue($event.target.checked)">
        <label class="custom-control-label lbl" for="customCheck1" data-toggle="tooltip" data-placement="top" v-bind:title="help">{{ vlabel }} <span v-if="bHelp" class="badge badge-secondary">?</span></label>
      </div>
    </div>
  </div>
-->
  <div style="width: 100%">
    <div class="form-check">
      <label class="lbl-edit" data-toggle="tooltip" data-placement="top" :title="title">
        <input type="checkbox" class="form-check-input" ref="cb" :checked="checked" :value="vvalue"
          @keydown.enter="focusControl" @change="updateValue($event.target.checked)"><span :style="customStyle">{{ vlabel
          }}</span> <span v-if="bHelp" class="badge badge-secondary">?</span>
      </label>
    </div>
  </div>
</template>

<script>
//https://br.vuejs.org/v2/guide/components.html#Usando-v-on-com-Eventos-Personalizados
import { SysVars } from '../main'
import { hasHiddenParent } from '../shared/utils';

export default {
  props: {
    'label': String,
    'title': String,
    'valueChecked': [String, Boolean],
    'valueUnchecked': [String, Boolean],
    'metadataField': Object,
    'value': [String, Boolean],
    customStyle: String
  },

  data() {
    return {
      vvalue: this.value,
      vlabel: '',
      help: '',
      bHelp: false,
      checked: false
    }
  },

  methods: {
    updateValue: function (value) {
      if (value) {
        this.vvalue = this.valueChecked
        this.checked = true
      } else {
        this.vvalue = this.valueUnchecked
        this.checked = false
      }
      this.$emit('input', this.vvalue)
    },

    focusControl: function (event) {
          event.preventDefault();
          var thisIndex = jQuery(this.$el.querySelector('input')).index(SysVars.sFocusControl)
          var next = thisIndex + 1
          var obj = jQuery(SysVars.sFocusControl)
          let found = false
          for (var x = next; x < obj.length; x++) {
            if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
              jQuery(obj[x]).focus()
              found = true
              break
            }
          }
          if (!found) {
            for (var x = 0; x < obj.length; x++) {
              if (jQuery(obj[x]).prop("tabindex") === 0 && !jQuery(obj[x]).is("disabled") && !hasHiddenParent(obj[x])) {
                jQuery(obj[x]).focus()
                found = true
                break
              }
            }
          }

          this.$emit('keyenter')
      },


  },

  watch: {
    value: function (newValue) {
      //console.log('checkbox value: ' + newValue)
      this.vvalue = newValue
      if (this.vvalue == this.valueChecked) {
        this.checked = true
      } else {
        this.checked = false
      }
    }
  },

  created() {
    //console.log('checkbox value created: ' + this.value)

    this.vvalue = this.value
    if (this.vvalue == this.valueChecked) {
      this.checked = true
    } else {
      this.checked = false
    }

    if (this.metadataField) {
      if (this.metadataField.help) {
        this.bHelp = true
        this.help = this.metadataField.help
      }
      if (this.metadataField.label) {
        this.vlabel = this.metadataField.label
      }
    }

    if (!this.vlabel) {
      this.vlabel = this.label
    }

  }

}
</script>




// WEBPACK FOOTER //
// src/components/input-checkbox.vue